import { TRANSLATION, Yup} from "@/imports-files/pages/clients/my-account";

const PASSWORD_FORMAT = /^(?=.*[A-Z])(?=.*\d).+$/;

export const MY_ACCOUNT = {
                              texts:{
                                      heading: 'My Account',
                                      add_btn : 'Add',
                                      upload_button: 'Upload new picture',
                                      label_1: 'Role',
                                      placeholder_1: 'Select Role',
                                      label_2: 'Name',
                                      placeholder_2: 'Name',
                                      label_3: 'Biography',
                                      label_4: 'Email address',
                                      placeholder_4: 'Email address',
                                      label_5: 'New password',
                                      placeholder_5: 'New password',
                                      label_6: 'Email Signature',
                                      optional: 'Optional',
                                      sign_out: 'Sign Out',
                                      save_changes:'Save Changes',
                                      next: 'Next',
                                      skip: 'Skip',
                                      label_7: 'Video Biography',
                                      label_8: 'Current password',
                                      placeholder_5: 'Current password'
                                    },
                              PHOTO_SIZE: 5000000,
                              VALIDATION_SCHEMA : Yup.object({
                                                                name: Yup.string().required(TRANSLATION('errors:required')),
                                                                email: Yup.string().email(TRANSLATION('errors:invalid_email')).required(TRANSLATION('errors:required')),
                                                                password: Yup.string().nullable().min(8, TRANSLATION('errors:short_password'))
                                                                                      .matches(PASSWORD_FORMAT, TRANSLATION('errors:password_format'))
                                                            })
                          }

export const QUESTIONS = [{
                            question: 'Introduce yourself to candidates and explain why they should work for your company?',
                            duration: 120,
                            description: '',
                            attempts: 3
                        }]